// #region imports

import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, BehaviorSubject } from 'rxjs';

// --- HS Code
import { OidcService } from '../account/oidc.service';
import { AppService } from '../app.service';
import {
  RegistrationTokenValidationModel,
  RegistrationValidationStages,
} from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root',
})
export abstract class RegistrationValidationBaseService {
  protected _validationStage$: BehaviorSubject<RegistrationValidationStages>;
  get validationStage$(): Observable<RegistrationValidationStages> {
    return this._validationStage$;
  }

  protected _validation$: BehaviorSubject<RegistrationTokenValidationModel | null>;
  get validation$(): Observable<RegistrationTokenValidationModel | null> {
    return this._validation$;
  }

  constructor(
    protected appService: AppService,
    protected oidcService: OidcService
  ) {
    this._validationStage$ = new BehaviorSubject<RegistrationValidationStages>(
      RegistrationValidationStages.validatingToken
    );
    this._validation$ = new BehaviorSubject<RegistrationTokenValidationModel | null>(
      null
    );
  }

  setValidationStage(stage: RegistrationValidationStages) {
    this._validationStage$.next(stage);
  }

  protected _authenticateFromOtac(otac: string) {
    this._validationStage$.next(RegistrationValidationStages.authenticating);
    this.oidcService.signInRedirect({
      extraQueryParams: {
        token: otac,
        acr_values: 'otac:' + otac,
        hasPassword: true,
      },
    });
  }

  abstract validateRegistrationToken(id: string): void;
}
